import { ISgSdkHandler, TriggerAction } from "./types";

declare const sdkHandler: ISgSdkHandler; 

export default function triggerGameOver(score) {
  return new Promise<void>(resolve => {
    sdkHandler.trigger(TriggerAction.GAME_OVER, {
      score,
      callback() {
        resolve();
      },
    })
  });
}
